import { IJWT } from "../IJWT";


export const extractPOOL_IDFromJWT = (jwt: IJWT) : string => {
    const parts = jwt.iss.split('/')
    const extractedString = parts[parts.length - 1]

    return extractedString
}


const parseUserPoolFromJWT = (JWT: any): string => {
    const parts = JWT?.iss?.split("/")
  
    return parts[parts.length - 1]
}

export const parseJwt = (token: string) => {
    // Split the token into its parts
    const base64Url = token.split('.')[1]
    
    // Decode the base64 string based on the environment
    let base64;
    if (typeof window !== 'undefined') {
        // Running in the browser
        base64 = atob(base64Url.replace(/-/g, '+').replace(/_/g, '/'))
    } else {
        // Running in Node.js
        base64 = Buffer.from(base64Url, 'base64').toString()
    }
    
    // Parse the JSON
    return JSON.parse(base64)
  }

export const claimsToUser = (claims: any) => {
    console.debug("claims", JSON.stringify(claims))  
    const first_name = claims.redwood_first_name || claims.given_name || ""
    const last_name = claims.redwood_last_name || claims.family_name || ""
    const email = claims.redwood_email || claims.email || ""
    const alias = claims.redwood_alias
    const sex =  claims.redwood_sex || ""
    const phone = claims.redwood_phone  || ""
    const address = claims.redwood_address || ""
    const postal = claims.redwood_postal || ""
    const city = claims.redwood_city || ""
    const country = claims.redwood_country || ""
    let publications = []
    if (claims?.redwood_pub_ids) {
      const pub_ids: string[] = JSON.parse(claims.redwood_pub_ids)
      for (const id of pub_ids) {
        publications.push({id})
      }
    }
    
    return {
      username: claims['cognito:username'],
      enabled: true,
      email,
      id: claims.redwood_user_id ? Number.parseInt(claims.redwood_user_id) : 0,
      first_name,
      last_name,
      full_name: `${first_name} ${last_name}`,
      roles: claims.redwood_roles ? JSON.parse(claims.redwood_roles) : [],
      uid: claims.redwood_uid,
      avatar: claims.redwood_avatar,
      publications,
      needs_activation: claims.redwood_needs_activation === "true",
      alias,
      sex,
      phone,
      address,
      postal,
      city,
      country,
      lan_code: claims.redwood_lan_code
    }            
}

